import { Component, ElementRef, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-basheng',
  templateUrl: './basheng.component.html',
  styleUrls: ['./basheng.component.scss']
})
export class BashengComponent implements OnInit {
  mUrl = this.api.mUrl;
  bashengList: any;
  details:any;
  Open = false;
  constructor(private api: ApiService,private el: ElementRef) { }

  ngOnInit(): void {
    this.Getbasheng();
  }
  Getbasheng() {
    this.api.Getbasheng().subscribe(
      data => this.bashengList = data
    )
  }
  Setdetails(item:any) {
    this.details = item;
    this.Open = true; 
    setTimeout(()=> {
      window.onmousewheel = (e) => {
        const ev = e || window.event;
      };
      this.el.nativeElement.querySelector('#scrollX').addEventListener('mousewheel', (e: any) => {
            e = e || window.event;
            const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
            this.el.nativeElement.querySelector('#scrollX').scrollLeft -= (delta * 40);
            e.preventDefault();
        }
      );
    },20)

  }
  removeHTML(html: any) {
    // console.log(html);
    let str = html.replace(/<p><br><\/p>/g,'');
    // console.log(str);
    return str;
  }
}
